import { FC, ReactElement } from 'react';
import { Box } from '@mui/material';

import DashboardHeader from './Dashboard.header';
import DashboardAside from './Dashboard.aside';

interface IDashboardLayout {
  children: ReactElement;
}

const DashboardLayout: FC<IDashboardLayout> = ({ children }): ReactElement => {
  return (
    <Box width="100%" display="flex" flexDirection="column" flex={1}>
      <DashboardHeader />
      <main style={{ display: 'flex', height: 'calc(100vh - 60px)' }}>
        <DashboardAside />
        <Box
          display="flex"
          width="100%"
          padding="30px 100px"
          sx={{ overflowY: 'auto', overflowX: 'auto' }}
        >
          {children}
        </Box>
      </main>
    </Box>
  );
};

export default DashboardLayout;
